module.exports = Em.Handlebars.compile("");